import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {  Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';

//import { Modal, ModalHeader, ModalBody, ModalFooter } from 'react-bootstrap';


class ModalComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

    }

    render() {

        const {title,modalState,modalBody,FooterVl,action} = this.props;

        return (
       
            <Modal backdrop="static" keyboard={false} isOpen={modalState} toggle={action} className="detail-modal modal-lg">
                <ModalHeader toggle={action}>{title}</ModalHeader>
                <ModalBody className="spc-radi">
                    {modalBody}
                </ModalBody>
                <ModalFooter>
                    {FooterVl}
                </ModalFooter>
            </Modal>
                    
        );
    }
}

function mapStateToProps(state) {
    return {
        
    };
}

export default withRouter(connect(mapStateToProps, {

})(ModalComponent));


// WEBPACK FOOTER //
// ./src/components/Layout/Modal.js